export default {
    variants: {
        accessoryAdder: {
            tablist: {
                gap: 2,
                paddingBottom: 6
            },
            tab: {
                border: '1px solid black',
                borderWidth: 0.5,
                borderRadius: '5px'
            },
            tabpanel: {
                padding: 0
            }
        },
        zoom: {
            root: {
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            },
            tab: {
                // reset chakra base style
                transitionDuration: null,
                transitionProperty: null,
                // custom styles
                whiteSpace: 'normal'
            },
            tablist: {},
            tabpanels: {
                minHeight: 0,
                height: '100%'
            },
            tabpanel: {
                // reset chakra base style
                p: null,
                // custom styles
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                overflow: 'hidden'
            }
        }
    },
    sizes: {
        none: {}
    }
}
